import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { WorkerAssignAcceptParam } from '../../models/gen/workerAssignAcceptParam';
import { WorkerAssignOutsourceMemberParam } from '../../models/gen/workerAssignOutsourceMemberParam';
import { WorkerAssignOutsourceMemberSearchParam } from '../../models/gen/workerAssignOutsourceMemberSearchParam';
import { WorkerAssignOutsourceMemberSearchResult } from '../../models/gen/workerAssignOutsourceMemberSearchResult';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const WORKER_ASSIGN_CONTEXT_NAMES = {
  POST_WORKER_ASSIGN_ACCEPT: 'acceptWorkerAssign',
  POST_WORKER_ASSIGN_OUTSOURCE_MEMBER: 'assignWorkerOutsourceMember',
  POST_WORKER_ASSIGN_OUTSOURCE_MEMBER_SEARCH: 'searchWorkerOutsourceMember',
} as const;

const apis = apiGenerator();

/**
 * POST /worker-assign/accept
 *
 * @param param -
 * @returns
 */
export const usePostWorkerAssignAccept = () =>
  useGenericMutation(async (param: WorkerAssignAcceptParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/worker-assign/accept`, { data: param })
  );

/**
 * POST /worker-assign/outsource-member
 *
 * @param param -
 * @returns
 */
export const usePostWorkerAssignOutsourceMember = () =>
  useGenericMutation(async (param: WorkerAssignOutsourceMemberParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/worker-assign/outsource-member`, {
      data: param,
    })
  );

/**
 * POST /worker-assign/outsource-member/search
 *
 * @param param -
 * @returns
 */
export const usePostWorkerAssignOutsourceMemberSearch = (
  param: WorkerAssignOutsourceMemberSearchParam
) =>
  useGenericQuery(
    [
      WORKER_ASSIGN_CONTEXT_NAMES.POST_WORKER_ASSIGN_OUTSOURCE_MEMBER_SEARCH,
      param as any,
    ],
    async (_param) =>
      apis.post<
        WorkerAssignOutsourceMemberSearchParam,
        WorkerAssignOutsourceMemberSearchResult
      >(`${env.BASE_API_ENDPOINT}/worker-assign/outsource-member/search`, {
        ...queryOptions,
        data: param,
      }),
    { enabled: false }
  );
